import { getQlikApp } from "../services/qlikService";
import type { RootState } from "../store/store";
import { setQlikFieldValList, setQlikFieldObject } from "../store/slice/qlikFieldsSlice";
import { store } from "../store/store"; // Import the Redux store
import { getQlikResources } from "../services/getQlikResources";
import { CYBER_CONFIG } from "../constants";
import { showSnackbar } from "../store/slice/snackbarSlice";

// Define types for Qlik field objects and values
interface QlikFieldValue {
  qText: string;
  qNum: number | null;
}

interface QlikFieldObject {
  name: string;
  app: string;
  object: any;
}

// Get the Redux state
const getState = (): RootState => store.getState();

// Dispatch Redux actions
const dispatch = store.dispatch;

/**
 * Fetch field values for a specific field and app.
 */
async function readListBoxData(name: string, appName: string, listBox: any): Promise<QlikFieldValue[]> {
  const layout = await listBox.getLayout();
  const fieldValues = layout.qListObject?.qDataPages[0]?.qMatrix as QlikFieldValue[];
  dispatch(setQlikFieldValList({ name, appName, fieldValues, objectId: layout.qInfo.qId  }));
  return fieldValues
}

export async function getFieldValues(name: string, appName: string, pageSize = 250, qlikSort:string, sortExpression: string, altState: string): Promise<void> {
  try {
    const qlikApp = await getQlikApp(appName);
    if (qlikApp) {
      const sortBy = sortExpression
        ? {
            qSortByExpression: 1,
            qExpression: { qv: sortExpression },
            qSortByState: 0,
            qSortByFrequency: 0,
            qSortByNumeric: 0,
            qSortByAscii: 0,
            qSortByLoadOrder: 0,
          }
        : qlikSort === 'qSortByAscii'
        ? {
            qSortByAscii: 1,
            qSortByState: 0,
            qSortByFrequency: 0,
            qSortByNumeric: 0,
            qSortByLoadOrder: 0,
            qSortByExpression: 0,
            qExpression: { qv: '' },
          }
        : {
            qSortByLoadOrder: 1,
            qSortByState: 0,
            qSortByFrequency: 0,
            qSortByNumeric: 0,
            qSortByAscii: 0,
            qSortByExpression: 0,
            qExpression: { qv: '' },
          };
      const listObjectDef = {
        qInfo: {
          qType: "ListObject"
        },
        qListObjectDef: {
          qStateName: altState,
          qDef: {
            qFieldDefs: [name],
            autoSort: !sortExpression,
            qSortCriterias: [sortBy],
          },
          qAutoSortByState: {
            qDisplayNumberOfRows: 1,
          },
          qShowAlternatives: true,
          qInitialDataFetch: [
            {
              qTop: 0,
              qLeft: 0,
              qHeight: pageSize,
              qWidth: 1,
            },
          ],
        },
      }
      const listBox = await qlikApp.createSessionObject(listObjectDef);
      await readListBoxData(name, appName, listBox);
      // Dispatch Redux action
      
      //Handling new selections applied
      listBox.on('changed', async () => {
        await readListBoxData(name, appName, listBox);
      });
    }
  }
  catch (error) {
    console.error(`Error fetching field values for field ${name} in app ${appName}:`, error);
    dispatch(showSnackbar({ reason: "error", message: CYBER_CONFIG.generalErrorMessage }));
  }
}

export default {
  getFieldValues
};